export default __webpack_public_path__ + "static/real-time-data-updates-aa552e114699103173fb5c60ecc6a9f2.png";